import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://rcremodel.com/#organization",
    "name": "RC Remodel",
    "alternateName": ["RC Remodel Services", "RC Remodeling", "RC Construction"],
    "description": "Professional home remodeling, kitchen renovation, bathroom upgrades, and custom construction services. Transform your space with our expert team. Licensed contractors serving the local area with over 10 years of experience.",
    "url": "https://rcremodel.com",
    "telephone": "313-631-6020",
    "email": "hi@rcremodel.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "123 Construction St",
      "addressLocality": "City",
      "addressRegion": "State",
      "postalCode": "12345",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.7128",
      "longitude": "-74.0060"
    },
    "openingHours": [
      "Mo-Fr 08:00-18:00",
      "Sa 09:00-16:00"
    ],
    "priceRange": "$$",
    "image": [
      "https://rcremodel.com/images/logos/RC Remodel Yellow BG.jpg",
      "https://rcremodel.com/images/hero/hero1.webp",
      "https://rcremodel.com/images/hero/hero2.webp",
      "https://rcremodel.com/images/hero/hero3.webp"
    ],
    "logo": "https://rcremodel.com/images/logos/RC Remodel Yellow BG.jpg",
    "sameAs": [
      "https://www.facebook.com/rcremodel",
      "https://www.instagram.com/rcremodels?igsh=MXU1bnQ5cjFmbm11YQ%3D%3D&utm_source=qr",
      "https://www.linkedin.com/company/rcremodel",
      "https://www.yelp.com/biz/rcremodel",
      "https://www.google.com/maps/place/rcremodel"
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "40.7128",
        "longitude": "-74.0060"
      },
      "geoRadius": "50000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Home Remodeling Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Kitchen Remodeling",
            "description": "Complete kitchen transformations with modern designs and premium materials.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bathroom Renovation",
            "description": "Luxury bathroom renovations with spa-like features and elegant finishes.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Full Home Renovation",
            "description": "Complete home transformations from foundation to finish.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Basement Finishing",
            "description": "Transform your basement into functional living space.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Home Additions",
            "description": "Expand your living space with seamless home additions and extensions.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bathroom Remodeling",
            "description": "Professional bathroom design and renovation services.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "RC Remodel"
            }
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Verified Customer"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Excellent work! RC Remodel transformed our kitchen beyond our expectations. Professional, timely, and high quality craftsmanship."
      }
    ],
    "foundingDate": "2014",
    "numberOfEmployees": "10-50",
    "currenciesAccepted": "USD",
    "paymentAccepted": ["Cash", "Check", "Credit Card", "Bank Transfer"],
    "isicV4": "43.21",
    "naics": "236118"
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://rcremodel.com/#organization",
    "name": "RC Remodel",
    "url": "https://rcremodel.com",
    "logo": "https://rcremodel.com/images/logos/RC Remodel Yellow BG.jpg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "313-631-6020",
      "contactType": "customer service",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.facebook.com/rcremodel",
      "https://www.instagram.com/rcremodels?igsh=MXU1bnQ5cjFmbm11YQ%3D%3D&utm_source=qr",
      "https://www.linkedin.com/company/rcremodel"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://rcremodel.com/#website",
    "url": "https://rcremodel.com",
    "name": "RC Remodel - Professional Home Remodeling Services",
    "description": "Professional home remodeling, kitchen renovation, bathroom upgrades, and custom construction services.",
    "publisher": {
      "@id": "https://rcremodel.com/#organization"
    },
    "inLanguage": "en-US",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://rcremodel.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://rcremodel.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://rcremodel.com/all-services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Gallery",
        "item": "https://rcremodel.com/gallery"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Contact",
        "item": "https://rcremodel.com/#contact"
      }
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What services does RC Remodel offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RC Remodel offers comprehensive home remodeling services including kitchen renovation, bathroom remodeling, full home renovation, basement finishing, home additions, and custom construction projects."
        }
      },
      {
        "@type": "Question",
        "name": "How long does a typical kitchen remodel take?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A typical kitchen remodel takes 4-8 weeks depending on the scope of work. We provide detailed timelines during the consultation process."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide free estimates?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide free, detailed estimates for all our remodeling projects. Contact us to schedule your consultation."
        }
      },
      {
        "@type": "Question",
        "name": "Are you licensed and insured?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, RC Remodel is fully licensed and insured. We carry comprehensive liability insurance and workers' compensation coverage."
        }
      },
      {
        "@type": "Question",
        "name": "What areas do you serve?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We serve the local area within a 50-mile radius. Contact us to confirm service availability in your specific location."
        }
      },
      {
        "@type": "Question",
        "name": "How much does a kitchen remodel cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kitchen remodel costs vary based on size and scope. We offer free estimates and can work within various budgets. Contact us for a personalized quote."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer financing options?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we offer flexible financing options to make your remodeling project more affordable. Ask about our financing programs during your free estimate."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
